import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaArrowUp,
  FaXTwitter,
} from "react-icons/fa6";

import { useNavigate } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigate = useNavigate();

  const handleNavigateToContact = () => {
    navigate("/Contact"); // Navigate first
    setTimeout(() => {
      // Scroll to top after a short delay to ensure page change
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100); // Adjust delay if needed
  };

  return (
    <footer className="bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-slate-400 text-sm mt-24 border-t border-slate-700/40">
      {/* C T A Section */}
      <div className="max-w-6xl mx-auto px-6 py-10 text-center">
        <h3 className="text-2xl font-semibold text-white mb-3">
          Let’s Work Together
        </h3>
        <p className="text-slate-400 mb-6 max-w-xl mx-auto">
          I’m always excited to collaborate on new projects or just chat tech!
          Feel free to reach out or connect with me online.
        </p>
        <button
          onClick={handleNavigateToContact}
          className="inline-block bg-gradient-to-r from-emerald-500 via-sky-500 to-indigo-500 text-white font-semibold px-6 py-3 rounded-lg shadow-md hover:shadow-indigo-400/30 hover:scale-105 transition-all duration-300"
        >
          Contact Me
        </button>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-slate-700/30">
        <p className="text-center md:text-left">
          &copy; {new Date().getFullYear()}{" "}
          <span className="text-indigo-400 font-semibold">Harsh Pariya</span>. All rights reserved.
        </p>

        <div className="flex space-x-6">
          <a href="/privacy" className="hover:text-emerald-400 transition">
            Privacy
          </a>
          <a href="/terms" className="hover:text-sky-400 transition">
            Terms
          </a>
        </div>

        <div className="flex space-x-5 text-lg">
          <a
            href="https://github.com/HarshPariya"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-emerald-400 transition duration-300"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/harsh-pariya/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-sky-400 transition duration-300"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://x.com/harshpariya_01"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-indigo-400 transition duration-300"
            aria-label="Twitter"
          >
            <FaXTwitter />
          </a>
          <a
            href="mailto:hpariya195@gmail.com"
            className="hover:text-pink-400 transition duration-300"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <div className="text-center py-6">
        <button
          onClick={scrollToTop}
          className="text-white bg-white/10 border border-slate-700 rounded-full p-3 hover:bg-white/20 transition duration-300"
          aria-label="Scroll to Top"
        >
          <FaArrowUp className="text-xl" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
